module.exports = __webpack_public_path__ + "static/media/welcome.3f1c650d.webm";